// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getHeader } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { headerPageFields } from "@store/Overrides/Pages/Header";

const useContactUsPageLink = () => {
    return useGetLink(useAppSelector(x => getHeader(x)).fields[headerPageFields.contactUsPageLink]);
};

export default useContactUsPageLink;
